import React from "react";
import ReactDOM from "react-dom/client";
import App from "./LaunchpadApp.js";
import { registerLicense } from "@syncfusion/ej2-base";
import "dotenv/config";
import { AuthProvider } from "./scripts/app.js";
import CssBaseline from "@mui/material/CssBaseline";
import { GlobalStyles, StyledEngineProvider } from "@mui/material";

registerLicense(
  "Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXxfcHRSQ2dYV0dxWEc="
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <React.StrictMode>
      <StyledEngineProvider injectFirst>
        <GlobalStyles styles="@layer theme, base, mui, components, utilities;" />
        <CssBaseline
        //  styles="@layer theme, base, mui, components, utilities;"
        />
        <App />
      </StyledEngineProvider>
    </React.StrictMode>
  </AuthProvider>
);
